"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helper = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const SaveSearchDialog_1 = require("../../containers/SaveSearchDialog");
const FilterColumns_1 = require("./FilterColumns");
const FilterPills_1 = require("./FilterPills");
const constants_1 = require("../../constants");
const ClearAllButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
    color: theme?.palette?.text?.link,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
}));
const ApplyButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    marginTop: theme.spacing(1),
    // @ts-ignore
    color: theme?.palette?.white,
    // @ts-ignore
    background: theme?.palette?.primary?.brown,
}));
const SwitchContainer = (0, material_1.styled)(material_1.Grid)(({ theme }) => ({
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
}));
const BoldLabel = (0, material_1.styled)(material_1.Typography)({
    fontWeight: "bold",
});
const SwitchLabel = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    opacity: 0.7,
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
}));
const FilterActionsContainer = (0, material_1.styled)("div")(({ theme }) => ({
    width: 180,
    minWidth: 180,
    margin: theme.spacing(1),
}));
const ChosenFiltersContainer = (0, material_1.styled)("div")({
    display: "flex",
});
const FilterPillsWrapper = (0, material_1.styled)("div")({
    flex: "1 1 auto",
});
const helper = ({ autoApply, setConjunction, setApplyButtonEnabled, setFilters, filters, onAutoApplyChange, deleteSavedSearch, onApply, objectType, conjunction, }) => {
    const self = {
        handleApply(updatedFilters, newConjunction) {
            const activeFilters = updatedFilters.map((filter) => ({
                ...filter,
                active: true,
            }));
            setFilters(activeFilters);
            setApplyButtonEnabled(false);
            if (onApply) {
                onApply({
                    filters: activeFilters,
                    conjunction: newConjunction || conjunction,
                    objectType,
                    name: objectType,
                    scope: "personal",
                });
            }
        },
        handleAdd(newFilter) {
            if (autoApply) {
                const updatedFilters = [
                    ...filters.map((filter) => ({ ...filter, active: true })),
                    { ...newFilter, active: true },
                ];
                self.handleApply(updatedFilters);
            }
            else {
                setFilters([...filters, newFilter]);
            }
            setApplyButtonEnabled(true);
        },
        handleDelete(index) {
            const updatedFilters = [...filters];
            updatedFilters.splice(index, 1);
            if (autoApply) {
                self.handleApply(updatedFilters);
            }
            else {
                setFilters(updatedFilters);
                setApplyButtonEnabled(true);
            }
        },
        handleConjunctionChange(event) {
            const newConjunction = event.target.checked
                ? constants_1.Conjunction.OR
                : constants_1.Conjunction.AND;
            setConjunction(newConjunction);
            setApplyButtonEnabled(true);
            if (autoApply) {
                self.handleApply(filters, newConjunction);
            }
            else {
                setFilters(filters.map((filter) => ({ ...filter, active: false })));
            }
        },
        handleAutoApply() {
            if (!autoApply) {
                self.handleApply(filters);
            }
            if (onAutoApplyChange) {
                onAutoApplyChange(!autoApply);
            }
        },
        handleSelectSavedSearch({ filters: newFilters, conjunction: newConjunction, }) {
            if (autoApply) {
                setFilters(newFilters.map((filter) => ({ ...filter, active: true })));
                self.handleApply(newFilters);
            }
            else {
                setFilters(newFilters);
            }
            setConjunction(newConjunction);
            setApplyButtonEnabled(true);
        },
        deleteSavedSearchHandler(id, objectType) {
            if (deleteSavedSearch) {
                deleteSavedSearch(id, objectType);
            }
        },
    };
    return self;
};
exports.helper = helper;
const AdvancedSearch = ({ objectType, filterOptions, showSaveSearchDialog = false, showFilterColumns = true, onSave, onSaveCancel, onApply, onFiltersChange = lodash_1.noop, onAutoApplyChange, initialConjunction = constants_1.Conjunction.AND, initialFilters = [], actionsEnabled = true, autoApply = true, pagination, currentYear, deleteSavedSearch, savedSearches = [], onError, search, saveSearchError, onSaveSearchError, }) => {
    const [filters, setFilters] = (0, react_1.useState)(initialFilters);
    const [applyButtonEnabled, setApplyButtonEnabled] = (0, react_1.useState)(false);
    const [conjunction, setConjunction] = (0, react_1.useState)(initialConjunction);
    (0, react_1.useEffect)(() => {
        // needed to allow resetting to blank from parent component
        setFilters(initialFilters);
    }, []);
    (0, react_1.useEffect)(() => {
        onFiltersChange(filters);
    }, [onFiltersChange, filters]);
    const { handleAdd, handleApply, handleDelete, handleConjunctionChange, handleAutoApply, handleSelectSavedSearch, deleteSavedSearchHandler, } = (0, exports.helper)({
        autoApply,
        filters,
        onApply,
        onAutoApplyChange,
        setApplyButtonEnabled,
        setConjunction,
        setFilters,
        deleteSavedSearch,
        conjunction,
        objectType,
    });
    const handleClear = () => {
        if (autoApply) {
            handleApply([]);
        }
        else {
            setFilters([]);
            setApplyButtonEnabled(true);
        }
    };
    const getPaginationLabel = ({ perPage, pageNumber, total }) => {
        const start = (pageNumber - 1) * perPage + 1 > total
            ? total
            : (pageNumber - 1) * perPage + 1;
        const end = pageNumber * perPage > total ? total : pageNumber * perPage;
        return `Showing: ${start} to ${end} of ${total.toLocaleString()} ${(0, lodash_1.capitalize)(objectType)}`;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showFilterColumns ? (react_1.default.createElement(FilterColumns_1.FilterColumns, { onAdd: handleAdd, onSelectSavedSearch: handleSelectSavedSearch, options: filterOptions, deleteSavedSearch: deleteSavedSearchHandler, objectType: objectType, savedSearches: savedSearches, onError: onError, search: search })) : null,
        react_1.default.createElement(ChosenFiltersContainer, { "data-testid": "AdvancedSearch_root" },
            react_1.default.createElement(FilterPillsWrapper, null,
                react_1.default.createElement(SwitchContainer, { container: true, alignItems: "center" },
                    react_1.default.createElement(SwitchLabel, { variant: "caption" }, "Match:"),
                    react_1.default.createElement(material_1.Grid, { item: true, component: "label" },
                        react_1.default.createElement(BoldLabel, { variant: "caption" }, "ALL"),
                        react_1.default.createElement(material_1.Switch, { checked: conjunction === "OR", onChange: handleConjunctionChange, color: "primary" }),
                        react_1.default.createElement(BoldLabel, { variant: "caption" }, "ANY")),
                    react_1.default.createElement(ClearAllButton, { color: "primary", onClick: handleClear },
                        react_1.default.createElement(material_1.Typography, { variant: "overline" }, "Clear All")),
                    pagination ? (react_1.default.createElement(material_1.Typography, { variant: "caption", "data-testid": "paginationLabel" }, getPaginationLabel(pagination))) : null),
                react_1.default.createElement(FilterPills_1.FilterPills, { filters: filters.map((filter) => ({
                        ...filter,
                        value: filter.displayedValue,
                    })), onDelete: handleDelete, conjunction: conjunction, currentYear: currentYear })),
            actionsEnabled && (react_1.default.createElement(FilterActionsContainer, null,
                react_1.default.createElement(material_1.FormControlLabel, { value: "Auto Apply", control: react_1.default.createElement(material_1.Switch, { "data-testid": "AdvancedSearch_autoApply_switch", checked: autoApply, onChange: handleAutoApply, color: "primary" }), label: react_1.default.createElement(SwitchLabel, { variant: "caption" }, "Auto Apply"), labelPlacement: "start" }),
                react_1.default.createElement(ApplyButton, { "data-testid": "AdvancedSearch_applyBtn", onClick: () => {
                        handleApply(filters);
                    }, variant: "contained", disabled: !applyButtonEnabled || autoApply }, "Apply Filters")))),
        showSaveSearchDialog && (react_1.default.createElement(SaveSearchDialog_1.SaveSearchDialog, { onSave: ({ title, viewableByAll }) => {
                if (onSave) {
                    onSave({
                        filters: filters.map((filter) => ({
                            ...filter,
                            active: false,
                        })),
                        conjunction,
                        name: title,
                        scope: viewableByAll ? "global" : "personal",
                        objectType,
                    });
                }
            }, onCancel: () => {
                if (onSaveCancel) {
                    onSaveCancel();
                }
            }, saveSearchError: saveSearchError, onSaveSearchResetError: onSaveSearchError }))));
};
exports.default = AdvancedSearch;
